import { TwoColumnsGridData } from "../components/TwoColumnsGrid";
import { Button, Checkbox, Grid, Paper, TextField, Typography, WithStyles, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import * as React from "react";
import { AppDispatch, IStore } from "src/store";
import { getApi } from "src/api/ApiProvider";
import { NotificationHistory } from "src/api/model";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import DriverHistoryLocation from "src/components/DriverHistoryLocation";
import DriverHistoryVisit from "src/components/DriverHistoryVisit";
import { NotificationActions } from "src/store/notification/notification-actions";
import { bindActionCreators } from "redux";
import { mockTheme, toMap } from "src/utils/utils";
import { Theme } from "@material-ui/core/es";
import { ConfigData } from "src/config";


const styles = (theme: Theme) => ({

});
const classesType = styles(mockTheme);

export interface OpportunityDataComponentProps extends WithStyles<keyof typeof classesType> {
    driverDetail: any;
    rutaMapa: () => string;
    config: ConfigData;
    notifActions: NotificationActions;
}

interface DriverDetailComponentState {
    colunms: TwoColumnsGridData[];
    startDate: string;
    endDate: string;
    notificationData: NotificationHistory[];
    tableNotification: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
        columnData: ColumnDefinition[]
    },
    historyVisitData: [];
    historyData: [];
    visited: boolean;
    races: boolean;
    pageNumber?: number;
    pageSize?: number;
    distanciaTotal: number;
    distanciaDiaActual: number;
    totalItems: number;
    driverId: number;
}

// const fd = (date: number | null | undefined, def: string) => {
//     if (!date) {
//         return def;
//     }
//     return new Date(date).toLocaleString();
// }

class DriverDetailComponent extends React.Component<OpportunityDataComponentProps, DriverDetailComponentState> {
    constructor(props: OpportunityDataComponentProps) {
        super(props);
        console.log('props', props)
        this.state = {
            colunms: [],
            startDate: '',
            endDate: '',
            notificationData: [],
            tableNotification: {
                data: [],
                sortBy: 'name',
                sortDirection: 'desc',
                columnData: [
                    { path: 'message', numeric: false, label: 'Mensaje' },
                    { path: 'type', numeric: false, label: 'Tipo' },
                    { path: 'notificacionDate', numeric: false, label: 'Fecha' },
                ]
            },
            historyVisitData: [],
            historyData: [],
            visited: true,
            races: true,
            pageNumber: 0,
            pageSize: 1000,
            distanciaTotal: 0,
            totalItems: 0,
            driverId: 0,
            distanciaDiaActual: 0
        }
        const { driverDetail } = props;

        this.handleClickNotification(driverDetail.id);


        if (driverDetail.user) {
            this.state.colunms.push(
                { type: 'divider' },
                { label: 'Email', value: driverDetail.user.email },
                { label: 'Telefono', value: driverDetail.phone },
                { label: 'Documento', value: driverDetail.document },
                { label: 'Telefono', value: driverDetail.phone },
                { label: 'Región', value: driverDetail.reigon }
            );
        }

        this.state.colunms.push(
            { type: 'title', label: 'Vehículo' },
            { type: 'divider' },
            { label: 'Marca', value: driverDetail.vehicle.brand ? driverDetail.vehicle.brand : 'Sin marca' },
            { label: 'Modelo', value: driverDetail.vehicle.model ? driverDetail.vehicle.model : 'Sin modelo' },
            { label: 'Tipo', value: driverDetail.vehicle.type ? driverDetail.vehicle.type : 'Sin tipo' },
            { label: 'Año', value: driverDetail.vehicle.year ? driverDetail.vehicle.year : 'Sin año' },

        );

        this.state.colunms.push(
            { type: 'title', label: 'Sucursal' },
            { type: 'divider' },
            { label: 'Nombre', value: driverDetail.branch.name ? driverDetail.branch.name : 'Sin nombre' },
            { label: 'Empresa', value: driverDetail.branch.company.name ? driverDetail.branch.company.name : 'Sin empresa' },

        );
    }

    componentDidMount(): void {
        this.getRecorridoActual();
    }

    handleClickNotification(id: number) {
        console.log('id', id)
        getApi().history().notificationHistory(id).then(
            (data: NotificationHistory[]) => {
                this.setState({ notificationData: data });
                // this.setState({ tabValue: 2 });
                // if (this.mapRef.current) {
                //     this.mapRef.current.focus();
                // }
            }).catch(err => {
                console.log('err', err)
            }
            )

    }

    //     if(rutaMapa && rutaMapa() !== "") {
    //     this.state.colunms.push(
    //         { type: 'title', label: 'Ruta' },
    //         { type: 'divider' }
    //     );
    //     ruta = rutaMapa();
    // };
    history = async (id: number) => {
        if (this.state.races) {
            const dateStart = new Date(this.state.startDate);
            const formattedDateStart = this.toLocalISOString(dateStart).slice(0, 16);

            const dateEnd = new Date(this.state.endDate);
            const formattedEndDate = this.toLocalISOString(dateEnd).slice(0, 16);

            const locationApi = getApi().history();
            try {
                const data = await locationApi.history(id, formattedDateStart, formattedEndDate);
                console.log('dataRecorrido', data)
                if (data.length === 0) {
                    return false;
                }
                this.setState({ historyData: data });
                return true;
            } catch (err) {
                console.log('err', err)
                return false;
            }
        }
        return false;
        // Do something with locationApi, startDate, endDate, and driverId
    };

    historyVisit = async (id: number) => {
        if (this.state.visited) {
            const dateStart = new Date(this.state.startDate);
            const formattedDateStart = this.toLocalISOString(dateStart).slice(0, 16);

            const dateEnd = new Date(this.state.endDate);
            const formattedEndDate = this.toLocalISOString(dateEnd).slice(0, 16);

            const locationApi = getApi().history();
            try {
                const data = await locationApi.historyVisit(id, formattedDateStart, formattedEndDate);
                console.log('funcHistoryVisit175', data)
                if (data.length === 0) {
                    return false;
                }
                this.setState({ historyVisitData: data });
                return true;
            } catch (err) {
                console.log('err', err)
                return false;
            }
        }
        return false
        // Do something with locationApi, startDate, endDate, and driverId
    };

    getRaces = async (pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string, driverId?: number): Promise<any> => {
        console.log(pageNum, pageSize, search, from, to)
        try {
            const data = await getApi().race().all(pageNum, pageSize, search, from, to,undefined, driverId);
            let sumaTotal = 0;
            data.content.map((item: any) => {
                if (item.type === 'RETORNO' || item.type === 'REMISION') {
                    sumaTotal += Math.round(item.route.length);
                }
            })
            return sumaTotal;
        } catch (error) {
            console.error('Error fetching races:', error);
            throw error;
        }
    }

    getRecorridoActual = async () => {
        const dateStart = new Date();
        dateStart.setHours(0, 0, 0, 0); // Establece la hora a las 00:00:00.000
        const formattedDateStart = this.toLocalISOString(dateStart).slice(0, 16);

        const dateEnd = new Date();
        dateEnd.setHours(23, 59, 59, 999); // Establece la hora a las 23:59:59.999
        const formattedEndDate = this.toLocalISOString(dateEnd).slice(0, 16);

        const getCarreras = await this.getRaces(this.state.pageNumber, this.state.pageSize, '', formattedDateStart, formattedEndDate, this.props.driverDetail.id);
        console.log('getCarreras232Init', getCarreras)
        this.setState({
            distanciaDiaActual: parseFloat(((getCarreras) / 1000).toFixed(1))
        });
    }

    getHistories = () => {
        return async () => {

            if (this.state.startDate === '' || this.state.endDate === '') {
                console.log('getHistories', this.state.startDate, this.state.endDate)
                this.props.notifActions.addWarning(
                    "Debe seleccionar un rango de fechas para buscar",
                    ""
                );
                return;
            }
            const { driverDetail } = this.props;
            const history = await this.history(driverDetail.id);
            const historyVisit = await this.historyVisit(driverDetail.id);
            const getCarreras = await this.getRaces(this.state.pageNumber, this.state.pageSize, '', this.state.startDate, this.state.endDate, driverDetail.id);
            console.log('getCarreras232', getCarreras)
            this.setState({
                distanciaTotal: parseFloat(((getCarreras) / 1000).toFixed(1))
            });

            console.log('data237', this.state.distanciaTotal)

            if (!history && !historyVisit) {
                this.props.notifActions.addWarning(
                    "Historial de recorridos y visitas",
                    "No se encontraron recorridos para las fechas seleccionadas"
                );
            } else if (!history) {
                this.props.notifActions.addWarning(
                    "Historial de recorridos",
                    "No se encontraron recorridos para las fechas seleccionadas"
                );
            } else if (!historyVisit) {
                this.props.notifActions.addWarning(
                    "Historial de visitas",
                    "No se encontraron visitas para las fechas seleccionadas"
                );
            }
        }
    }

    cleanSearch = () => {
        return () => {
            this.setState({ startDate: '', endDate: '', historyData: [], historyVisitData: [], distanciaTotal: 0,});
        }
    }


    toLocalISOString = (date: Date) => {
        const tzo = -date.getTimezoneOffset();
        const dif = tzo >= 0 ? '+' : '-';
        const pad = (num: number) => {
            const norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(tzo / 60) +
            ':' + pad(tzo % 60);
    }

    render() {
        return (
            <Grid container direction='row' alignItems="center" alignContent="center">
                <Grid container justify="center">
                    <Typography variant="display1" style={{ textAlign: 'center' }}>{this.props.driverDetail.user.name + `#` + this.props.driverDetail.user.id},</Typography>
                </Grid>
                <Grid container direction='row'>
                    <Grid item md={6}>
                        <Paper elevation={1} style={{ padding: 10, margin: 8 }}>
                            <Grid container direction='row'>
                                <Grid item md={4}>
                                    <h4 style={{ marginBottom: '20px' }}>Datos personales</h4>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Email: ${this.props.driverDetail.user.email}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Telefono: ${this.props.driverDetail.phone}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Documento: ${this.props.driverDetail.document}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Telefono: ${this.props.driverDetail.phone}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Región: ${this.props.driverDetail.region}`}</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <h4 style={{ marginBottom: '20px' }}>Datos del vehículo</h4>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Marca: ${this.props.driverDetail.vehicle.brand ? this.props.driverDetail.vehicle.brand : 'Sin marca'}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Modelo: ${this.props.driverDetail.vehicle.model ? this.props.driverDetail.vehicle.model : 'Sin modelo'}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Tipo: ${this.props.driverDetail.vehicle.type ? this.props.driverDetail.vehicle.type : 'Sin tipo'}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Año: ${this.props.driverDetail.vehicle.year ? this.props.driverDetail.vehicle.year : 'Sin año'}`}</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <h4 style={{ marginBottom: '30px' }}>Datos de la empresa</h4>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Nombre: ${this.props.driverDetail.branch.name ? this.props.driverDetail.branch.name : 'Sin nombre'}`}</Typography>
                                    <Typography style={{ marginBottom: '20px' }} variant="body1">{`Empresa: ${this.props.driverDetail.branch.company.name ? this.props.driverDetail.branch.company.name : 'Sin empresa'}`}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item md={6}>
                        <AsyncTable
                            columnDefinition={this.state.tableNotification.columnData}
                            title='Notificaciones'
                            data={this.state.notificationData}
                            defaultOrder={{
                                name: 'time',
                                direction: 'desc'
                            }}
                        />
                    </Grid>
                    <Grid container direction='row' alignItems="flex-start" justify="space-between">
                        <Grid container direction='row' alignItems="baseline" justify="flex-start">

                            <Typography style={{ marginRight: 8 }}>Desde</Typography>
                            <TextField
                                required
                                type="datetime-local"
                                value={this.state.startDate}
                                onChange={e => this.setState({ startDate: e.target.value })}
                            />
                            <Typography style={{ marginRight: 8 }}>Hasta</Typography>
                            <TextField
                                required
                                type="datetime-local"
                                value={this.state.endDate}
                                onChange={e => this.setState({ endDate: e.target.value })}
                            />
                            <Button onClick={this.getHistories()} color="primary" style={{ border: '1px solid black', marginLeft: 8 }}>
                                Buscar <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-search"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
                            </Button>
                        </Grid>
                        <Grid container direction='row' alignItems="center" justify="flex-start">

                            <Typography style={{ marginRight: 8 }}>Recorridos</Typography>
                            <Checkbox
                                checked={this.state.races}
                                onChange={e => this.setState({ races: e.target.checked }, () => {
                                    if (!this.state.visited) {
                                        this.setState({ historyData: [] })
                                    }
                                })}
                                inputProps={{ 'aria-label': 'Recorridos' }}
                            />
                            <Typography style={{ marginRight: 8 }}>Visitas</Typography>
                            <Checkbox
                                checked={this.state.visited}
                                onChange={e => this.setState({ visited: e.target.checked }, () => {
                                    if (!this.state.visited) {
                                        this.setState({ historyVisitData: [] })
                                    }
                                })}
                                inputProps={{ 'aria-label': 'Visitas' }}
                            />

                            <Button onClick={this.cleanSearch()} color="primary" style={{ border: '1px solid black', marginLeft: 8 }}>
                                Limpiar búsqueda <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-trash"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                            </Button>


                        </Grid>
                        <Grid item md={12}>
                            <h4>Total distancia del día: {this.state.distanciaDiaActual} km</h4>
                            <h4>Total distancia filtrada: {this.state.distanciaTotal} km</h4>
                        </Grid>
                        <Grid item md={6}>
                            <h4>Recorridos</h4>
                            <Paper elevation={1} style={{ padding: 10, margin: 8 }}>
                                <DriverHistoryLocation data={this.state.historyData} config={this.props.config} />
                            </Paper>
                        </Grid>
                        <Grid item md={6}>
                            <h4>Visitas</h4>
                            <Paper elevation={1} style={{ padding: 10, margin: 8 }}>
                                <DriverHistoryVisit
                                    data={this.state.historyVisitData} config={this.props.config} />
                            </Paper>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>);
    };
}

// const mapStateToProps = (state: IStore, ownProps: OpportunityDataComponentProps) => ({
//     ...ownProps,
//     config: state.config.data,
// });

// export default connect(mapStateToProps)(DriverDetailComponent);

const mapStateToProps = (state: IStore, ownProps: OpportunityDataComponentProps) => ({
    ...ownProps,
    // config: state.config.data,
});

const styled = withStyles(styles as any)(DriverDetailComponent);

const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
    return {
        notifActions: bindActionCreators(toMap(NotificationActions), dispatch),
    };
})(styled);

export default connected as React.ComponentClass<Partial<OpportunityDataComponentProps>>;



// WEBPACK FOOTER //
// ./src/pages/DriverDetailComponent.tsx